import React from 'react'

export const PageBuildContext = React.createContext({ noIndex: false })
